import { Action, configureStore, ThunkAction } from '@reduxjs/toolkit';
import { authApi } from '../store/auth/authApi';
import { userAPI } from '../store/user/userApi';
import {reservationsAPI} from '../store/reservations/reservationsApi';
import { userDomAPI } from '../store/user/userDomApi';
import samplesSlice from '../store/brokers/admin/sample/samplesSlice';
import suppliersSlice from '../store/brokers/admin/suppliers/SuppliersSlice';
import purchasesSlice from '../store/brokers/partner/purchases/PurchasesSlice';
import invoicesSlice from '../store/brokers/suppliers/invoices/InvoicesSlice';
import assetsSlice from '../store/brokers/partner/assets/assetsSlice';
import { companyUsersApi } from '../store/company-users/companyUsersApi';
import { googleReservationsAPI } from '../store/google-reservations/googleReservationsApi';

export const store = configureStore({
    reducer: {
        [userAPI.reducerPath]: userAPI.reducer,
        [authApi.reducerPath]: authApi.reducer,
        [userDomAPI.reducerPath]: userDomAPI.reducer,
        samples: samplesSlice,
        suppliers: suppliersSlice,
        purchases: purchasesSlice,
        invoices: invoicesSlice,
        assets: assetsSlice,
		[reservationsAPI.reducerPath]: reservationsAPI.reducer,
		[companyUsersApi.reducerPath]: companyUsersApi.reducer,
		[googleReservationsAPI.reducerPath]: googleReservationsAPI.reducer,

    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().concat(userAPI.middleware, authApi.middleware, reservationsAPI.middleware, companyUsersApi.middleware, googleReservationsAPI.middleware),
})

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;